import { StarSuperLite } from '@apeiron/star'
import { deserializeData } from '@apeiron/temp'
import { useQuery } from '@apollo/client'
import { starSuperLiteSchema } from '@src/deserialize/yup/star'
import graphql from '@src/graphql/query/getStarSuperLite'
import * as R from 'ramda'
import * as RA from 'ramda-adjunct'
import { useCallback, useEffect, useState } from 'react'

const useGetStarSuperLite = (starID: string): Hook => {
  const {
    data: apllocData,
    loading,
    refetch: apllocRefetch
  } = useQuery(graphql, {
    variables: { starID },
    skip: RA.isNilOrEmpty(starID),
    ssr: false
  })

  const [data, setData] = useState<StarSuperLite | null>(null)

  const refetch = useCallback(
    (starId?: string) => {
      if (R.isNil(starId)) {
        apllocRefetch()
      } else {
        apllocRefetch({ starID: starId })
      }
    },
    [apllocRefetch]
  )

  useEffect(() => {
    if (!R.isNil(apllocData)) {
      const star = deserializeData<StarSuperLite>(
        { data: apllocData },
        starSuperLiteSchema
      )

      if (!R.isNil(star)) {
        setData(star)
      }
    }
  }, [apllocData])

  return {
    data,
    loading,
    refetch
  }
}

type Response = StarSuperLite | null

type Hook = {
  data: Response
  loading: boolean
  refetch: (starId?: string) => void
}

export default useGetStarSuperLite
